<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          style="cursor:pointer"
        >view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <div class="row dblock">
              <div class="row">
                <div class="col-md-12">
                  <vs-breadcrumb
                    align="left"
                    :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Map',
                      active: true
                    }
                  ]"
                  ></vs-breadcrumb>
                  <div class="heading mt-3">
                    <h3 class="text-secondary">Map</h3>
                  </div>
                </div>
              </div>

            <div class="col-sm-12">
                <div id="map-pakistan"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    isSidebar: false,
    trainingArr: [],
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    this.unassignedTrainings();
       var data = [
          ['pk-sd', 0],
    ['pk-ba', 1],
    ['pk-jk', 2],
    ['pk-na', 3],
    // ['pk-nw', 4],
    // ['pk-ta', 5],
    // ['pk-is', 6],
    ['pk-pb', 7]
];

// Create the chart
Highcharts.mapChart('map-pakistan', {
    chart: {
        map: 'countries/pk/pk-all'
    },

    // title: {
    //     text: 'Highmaps basic demo'
    // },

    // subtitle: {
    //     text: 'Source map: <a href="http://code.highcharts.com/mapdata/countries/pk/pk-all.js">Pakistan</a>'
    // },

    mapNavigation: {
        enabled: false,
        // buttonOptions: {
        //     verticalAlign: 'bottom'
        // }
    },

    colorAxis: {
       showInLegend: false,
         min: [0],
         max:[8]
    },

    series: [{
        data: data,
        name: 'Total Participants: 20 <br>',
        states: {
          hover: {
                color: '#BADA55'
            }
        },
        dataLabels: {
            enabled: true,
            format: '{point.name}'
        },
       tooltip: {
            pointFormat: 
                //  'Total Participants: 20 <br>' +
                 'Male: 15 <br>' +
                 'Female: 5<br>'
        },
    }]
});

  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    // this will route to training wizard
   

    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    unassignedTrainings: function unassignedTrainings(){
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/get/all/training/reports/admin/" +
          JSON.parse(localStorage.getItem("currentUser")).id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingArr = response.data;
      });
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    closeEditForm() {
      this.isForm = true;
      this.isEditForm = false;
      this.title = "";
      this.code = "";
    },
  }
};
</script>
<style>
rect.highcharts-legend-box{
  display: none !important;
}
g.highcharts-legend-item.highcharts-map-series.highcharts-color-0.highcharts-series-0{
  display:none !important;
}


</style>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
 #map-pakistan{
  height: 500px; 
    min-width: 510px; 
    max-width: 1000px; 
    margin: 0 auto; 
}


/* g.highcharts-legend-item.highcharts-undefined-series.highcharts-color-undefined{
  display: none !important;
} */

.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}

</style>

